const GOOGLE_ANALYTICS_EVENTS = {
    SearchInitiated: {
        name: 'ST Search Initiated',
        category: 'ST Search',
        action: 'st-search-bar-focus',
    },
    SearchQuery: {
        name: 'ST Search Query',
        category: 'ST Search',
    },
    DefaultSearchQuery: {
        name: 'view_search_results',
        category: 'ST Autocomplete',
    },
    ViewedProduct: {
        name: 'ST Viewed Product',
        category: {
            placeholder: "ST Search Page",
        },
        action: {
            placeholder: "st-search-page-product-click",
        },
    },
    Filters: {
        name: 'ST Filters',
        category: {
            bubbleFilters: 'ST Bubble Filters',
            sideFilters: 'ST Side Filters',
        },
        action: {
            bubbleFilters: 'st-bubble-filter-click',
            sideFilters: 'st-side-filter-click',
        },
    },
    Sort: {
        name: 'ST Sort',
        category: 'ST Search Page',
        action: 'st-sort-click',
    },
    AddToCart: {
        name: 'Product Added in the Cart via SearchTap',
        category: 'ST Add To Cart',
        action: 'st-add-to-cart-click',
    },
    SearchSuggestions: {
        name: 'ST Search Suggestions',
        category: 'ST Autocomplete',
        action: {
            click: "st-search-suggestions-click",
            redirect: "st-search-suggestions-redirect",
        },
    },
    TrendingSearches: {
        name: 'ST Trending Searches',
        category: 'ST Autocomplete',
        action: {
            click: "st-trending-search-click",
            redirect: "st-trending-search-redirect",
        },
    },
};

const GoogleAnalyticsTrackerType = {
    GTag: 'gtag',
    GTM: 'gtm'
};

module.exports = class GoogleAnalytics {
    constructor(tracker, trackingID, debugMode = false) {
        this.tracker = tracker;
        this.debugMode = debugMode;
        this.trackingID = trackingID;

        if (this.tracker === GoogleAnalyticsTrackerType.GTag && !this.debugMode) {
            try {
                window.gtag("config", this.trackingID);
            } catch (e) {
                console.log(e);
            }
        }
    }

    trackEvent(eventName, eventData) {
        if (this.debugMode) {
            console.log(`[Google Analytics] Event Recorded:`);
            console.log(`  - Tracker Type: ${this.tracker}`);
            console.log(`  - Event: ${eventName}`);
            console.log(`  - Data: ${JSON.stringify(eventData, null, 2)}`);
            return;
        }
        try {
            switch (this.tracker) {
                case GoogleAnalyticsTrackerType.GTag:
                    window.gtag("event", eventName, eventData);
                    break;
                case GoogleAnalyticsTrackerType.GTM:
                    window.dataLayer.push(Object.assign({ event: eventName }, eventData));
                    break;
                default:
                    console.log(`Invalid Tracker`);
                    break;
            }
        } catch (error) {
            console.error(`Error tracking event '${eventName}': ${error}`);
        }
    }

    recordQuery(q) {
        const eventType = GOOGLE_ANALYTICS_EVENTS.SearchQuery;

        const eventData =
            this.tracker === GoogleAnalyticsTrackerType.GTag
                ? {
                    search_term: q,
                    send_to: this.trackingID,
                }
                : {
                    event_category: eventType.category,
                    event_label: q,
                };

        this.trackEvent(eventType.name, eventData);
    }

    recordSearchStartEvent() {
        const eventData = {
            event_category: GOOGLE_ANALYTICS_EVENTS.SearchInitiated.category,
            event_action: GOOGLE_ANALYTICS_EVENTS.SearchInitiated.action,
        };

        this.trackEvent(GOOGLE_ANALYTICS_EVENTS.SearchInitiated.name, eventData);
    }

    recordProductViewedEvent(item) {
        const eventData = {
            event_category:
                GOOGLE_ANALYTICS_EVENTS.ViewedProduct.category.placeholder.replace(
                    "{category}"
                ),
            event_label: item,
            event_action:
                GOOGLE_ANALYTICS_EVENTS.ViewedProduct.action.placeholder.replace(
                    "{action}"
                ),
        };

        this.trackEvent(GOOGLE_ANALYTICS_EVENTS.ViewedProduct.name, eventData);
    }

    recordFilterEvent(filter, isBubbleFilter = false) {
        const eventData = {
            event_category: isBubbleFilter
                ? GOOGLE_ANALYTICS_EVENTS.Filters.category.bubbleFilters
                : GOOGLE_ANALYTICS_EVENTS.Filters.category.sideFilters,
            event_label: filter,
            event_action: isBubbleFilter
                ? GOOGLE_ANALYTICS_EVENTS.Filters.action.bubbleFilters
                : GOOGLE_ANALYTICS_EVENTS.Filters.action.sideFilters,
        };

        this.trackEvent(GOOGLE_ANALYTICS_EVENTS.Filters.name, eventData);
    }

    recordSortEvent(sortName) {
        const eventData = {
            event_category: GOOGLE_ANALYTICS_EVENTS.Sort.category,
            event_label: sortName,
            event_action: GOOGLE_ANALYTICS_EVENTS.Sort.action,
        };

        this.trackEvent(GOOGLE_ANALYTICS_EVENTS.Sort.name, eventData);
    }

    recordCartEvent(itemName) {
        const eventData = {
            event_category: GOOGLE_ANALYTICS_EVENTS.AddToCart.category,
            event_label: itemName,
            event_action: GOOGLE_ANALYTICS_EVENTS.AddToCart.action,
        };

        this.trackEvent(GOOGLE_ANALYTICS_EVENTS.AddToCart.name, eventData);
    }

    recordAutocompleteLabelClickEvent(itemName, isSearchSuggestion, isRedirectType = false) {
        const eventType = isSearchSuggestion
            ? GOOGLE_ANALYTICS_EVENTS.SearchSuggestions
            : GOOGLE_ANALYTICS_EVENTS.TrendingSearches;

        const eventData = {
            event_category: eventType.category,
            event_label: itemName,
            event_action: isRedirectType
                ? eventType.action.redirect
                : eventType.action.click,
        };

        this.trackEvent(eventType.name, eventData);
    }
}


// WEBPACK FOOTER //
// ./src/google-analytics.js